<template>
    <b-modal
        id="modalRemovePhoto"
        ref="modalRemovePhoto"
        :lazy="true"
        title-tag="h2"
        title="Remove Photo"
    >
        <span
            >Do you wish to remove this photo? This action cannot be
            undone.</span
        >
        <div slot="modal-footer" class="w-100">
            <b-button
                v-if="!loading"
                @click="$refs.modalRemovePhoto.hide('cancel')"
                class="float-left"
                variant="secondary"
                >Cancel</b-button
            >
            <div class="float-right">
                <img v-if="loading" src="assets/ajax-loader.gif" />
                <b-button
                    v-if="!loading"
                    @click="proceed"
                    class="float-left"
                    variant="primary"
                    >Remove</b-button
                >
            </div>
        </div>
    </b-modal>
</template>
<script>
import Client from "@/services/client";

export default {
    name: "ModalUploadPhoto",
    components: {},
    data() {
        return {
            loading: false,
            module: ""
        };
    },
    methods: {
        open(module) {
            this.module = module;
            this.$refs.modalRemovePhoto.show();
        },
        proceed() {
            let self = this;
            self.loading = true;

            let params = {};
            let whichStore = null;
            let encodedId = null;
            if (this.module == "CLIENT") {
                params.id = self.$store.state.client.client_id;
                params.isClient = 1;
                whichStore = "client/getClientDetails";
                encodedId = self.$store.state.client.client_details.encoded_id;
            } else {
                params.id = self.$store.state.patient.patientDetails.id;
                params.isClient = 0;
                whichStore = "patient/getPatientDetails";
                encodedId = self.$store.state.patient.patientDetails.encoded_id;
            }
            Client.deletePhoto(params).then(res => {
                if (res.response && res.response.code == 200) {
                    self.$store
                        .dispatch(whichStore, {
                            id: encodedId,
                            encoded: true
                        })
                        .then(details => {
                            if (self.module == "PATIENT") {
                                self.$root.$emit(
                                    "update-patient-details",
                                    details
                                );
                                self.$emit("refresh-photo");
                            }
                        })
                        .finally(() => {
                            self.$refs.modalRemovePhoto.hide();
                            self._message(res.response.message, "success");
                        });
                } else {
                    self._message(res.response.message, "danger");
                }
            });
        }
    }
};
</script>
